import { useMutation, useQuery } from '@apollo/client'
import { useState } from 'react'
import toast from 'react-hot-toast'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'

import {
  FIX_MISSING_PAGE_INDEXES,
  FIX_MISSING_PAGE_TYPES
} from 'data/layoutcreator/mutations/migrations'
import IslandModal, {
  IslandModalProps
} from 'shared/components/modals/IslandModal'
import Button, { ButtonIntents } from 'shared/ui/Button'
import Flex from 'shared/ui/Flex'
import Select from 'shared/ui/Select'

const Label = styled.label`
  font-weight: 600;
  margin-bottom: 12px;
`

type MissingPagePropertiesMigrationModalProps = Pick<
  IslandModalProps,
  'isOpen' | 'closeModal'
>

const MissingPagePropertiesMigrationModal: React.FC<
  MissingPagePropertiesMigrationModalProps
> = ({ isOpen, closeModal }) => {
  const { projectId } = useParams()
  const [selectedProperty, setSelectedProperty] = useState<number>(0)

  const [fixMissingPageIndexes] = useMutation(
    FIX_MISSING_PAGE_INDEXES
  )
  const [fixMissingPageTypes] = useMutation(FIX_MISSING_PAGE_TYPES)

  const MIGRATIONS: Array<{
    label: string
    mutation:
      | typeof fixMissingPageIndexes
      | typeof fixMissingPageTypes
    mutationName: 'fixMissingPageIndexes' | 'fixMissingPageTypes'
  }> = [
    {
      label: 'index',
      mutation: fixMissingPageIndexes,
      mutationName: 'fixMissingPageIndexes'
    },
    {
      label: 'type',
      mutation: fixMissingPageTypes,
      mutationName: 'fixMissingPageTypes'
    }
  ]

  const handleStartClick = async () => {
    const toastId = toast.loading('Starting migration...')
    const mutation = MIGRATIONS[selectedProperty].mutation

    try {
      const result = await mutation({
        variables: { projectId: projectId as string }
      })

      const migration = MIGRATIONS[selectedProperty]

      if ((result.data as any)[migration.mutationName]) {
        return toast.success('Migration finished', { id: toastId })
      }

      throw new Error()
    } catch (error) {
      console.error(error)
      toast.error('Migration failed', { id: toastId })
    }
  }

  return (
    <IslandModal
      isOpen={isOpen}
      closeModal={closeModal}
      title="Migrations"
      titleAlign="left"
      titleSize={22}
    >
      <Flex columnGap={40}>
        <Flex width={400} direction="column" height="fit-content">
          <Flex direction="column" flex={1} marginBottom={30}>
            <Label>Property:</Label>
            <Select
              options={MIGRATIONS.map(migration => migration.label)}
              activeIndex={selectedProperty}
              onChange={(_, index) => setSelectedProperty(index)}
            />
          </Flex>

          <Button
            labelId="Start"
            onClick={handleStartClick}
            intent={ButtonIntents.dark}
            borderRadius={100}
          />
        </Flex>
      </Flex>
    </IslandModal>
  )
}

export default MissingPagePropertiesMigrationModal
